<div class="screen screen--events">

  <header class="screen__head">
    <p class="belturo-eyebrow"><%= _lcs( 'Entdecken' ) %></p>
    <h1 class="screen__title"><%= _lcs( 'Veranstaltungen' ) %></h1>
  </header>

  <!-- No chips when there is only one scope to look at — see filtersFor(). -->
  <% if ( hasEvents && filters.length > 0 ) { %>
  <div class="chips" data-id="filters">
    <% filters.forEach( function( f, i ) { %>
      <button class="chip <%= i === 0 ? 'chip--active' : '' %>" type="button" data-filter="<%= f.id %>"><%= _lcs( f.label ) %></button>
    <% } ); %>
  </div>
  <% } %>

  <div class="eventlist" data-id="list">
    <% events.forEach( function( e ) { %>
      <button class="eventcard" type="button" data-event="<%= e.id %>" data-scope="<%= e.scope %>">
        <span class="eventcard__media ga-photo ga-photo--<%= e.photo %>">
          <% if ( e.image ) { %>
            <img class="eventcard__photo" src="<%= e.image %>" alt="<%= e.imageAlt %>" loading="lazy" />
          <% } else { %>
            <i class="icon icon--<%= e.icon %> ga-photo__glyph"></i>
          <% } %>
          <span class="badge <%= e.scope === 'own' ? 'badge--solid' : 'badge--accent' %> badge--sm eventcard__scope"><%= e.scope === 'own' ? _lcs( 'Vom Haus' ) : _lcs( 'Region' ) %></span>
          <span class="datechip datechip--float">
            <span class="datechip__day"><%= e.day %></span>
            <span class="datechip__mon"><%= e.mon %></span>
          </span>
        </span>
        <span class="eventcard__body">
          <span class="eventcard__top">
            <span class="badge badge--brand badge--sm"><%= e.cat %></span>
            <% if ( e.status ) { %>
              <span class="badge badge--accent badge--sm"><%= e.status %></span>
            <% } %>
            <%# A running date's start may lie days back; a date that has only
                begun keeps its start time: "Hat begonnen · 09:00 Uhr". %>
            <% if ( !e.running ) { %>
              <span class="eventcard__time"><%= e.allDay ? _lcs( 'ganztägig' ) : _lcs( '{time} Uhr', { time: e.time } ) %></span>
            <% } %>
          </span>
          <span class="eventcard__title"><%= e.title %></span>
          <% if ( e.desc ) { %><span class="eventcard__desc"><%= e.desc %></span><% } %>
          <span class="eventcard__foot">
            <span class="eventcard__loc"><i class="icon icon--map-pin"></i><%= e.dist ? e.loc + ' · ' + e.dist : e.loc %></span>
            <span class="eventcard__details"><%= _lcs( 'Details' ) %> <i class="icon icon--arrow-right"></i></span>
          </span>
        </span>
      </button>
    <% } ); %>

    <% if ( hasEvents ) { %>
    <p class="eventlist__empty" data-id="filter-empty" hidden>
      <%= _lcs( 'In dieser Auswahl steht gerade nichts an.' ) %>
    </p>
    <% } %>
  </div>

  <% if ( !hasEvents ) { %>
  <div class="eventlist">
    <div class="eventlist__none">
      <span class="eventlist__none-icon"><i class="icon icon--<%= failed ? 'triangle-alert' : 'calendar' %>"></i></span>
      <h2 class="eventlist__none-title">
        <%= failed ? _lcs( 'Veranstaltungen nicht verfügbar' ) : _lcs( 'Aktuell nichts geplant' ) %>
      </h2>
      <p class="eventlist__none-text">
        <% if ( failed ) { %>
          <%= _lcs( 'Die Veranstaltungen konnten gerade nicht geladen werden. Bitte versuche es später noch einmal.' ) %>
        <% } else { %>
          <%= _lcs( 'Für die nächsten Tage sind noch keine Veranstaltungen eingetragen. Frag gern deinen Gastgeber — oft gibt es kurzfristige Tipps.' ) %>
        <% } %>
      </p>
    </div>
  </div>
  <% } %>

  <% if ( canWiden ) { %>
  <!-- The list is kept to the guest radius by default (core-api
       GeoQuery.GUEST_RADIUS_KM); this is the way past it, and back. -->
  <div class="eventlist__radius">
    <p class="eventlist__radius-text">
      <%= wide ? _lcs( 'Alle Veranstaltungen der Region.' ) : _lcs( 'Veranstaltungen bis {km} km Entfernung.', { km: radiusKm } ) %>
    </p>
    <button class="eventlist__radius-btn" type="button" data-id="toggle-radius">
      <%= wide ? _lcs( 'Nur in der Nähe anzeigen' ) : _lcs( 'Auch weiter entfernte anzeigen' ) %>
    </button>
  </div>
  <% } %>

</div>
